import { Customer } from 'types';
import { CustomerActions } from 'types/store/actions/customers';
import { CustomerActionTypes } from 'types/store/actions/constants';

// eslint-disable-next-line import/prefer-default-export
export const fetchSuccess = (customer: Customer): CustomerActions => ({
  type: CustomerActionTypes.FETCH_SUCCESS,
  payload: customer,
});
